import * as Yup from "yup";

const grupoTributarioModeloTributacaoValidator = Yup.object().shape({
  tipoOperacao: Yup.string().required("Tipo Operação"),
  estadosId: Yup.array().min(1, "UF Destino").required("UF Destino"),
  operacoesFiscalId: Yup.array()
    .min(1, "Operação Fiscal")
    .required("Operação Fiscal"),
  grupoTributarioId: Yup.number().required("Grupo Tributario"),
  csoSimplesNacional: Yup.string().when("isCombustivel", {
    is: false,
    then: Yup.string().nullable().required("CSO"),
    otherwise: Yup.string().nullable(),
  }),
  codigoCst: Yup.string().when("isCombustivel", {
    is: true,
    then: Yup.string().required("CST"),
    otherwise: Yup.string().nullable(),
  }),
  cfopId: Yup.number().required("CFOP"),
  aliquotaAdrem: Yup.number().when("isCombustivel", {
    is: true,
    then: Yup.number().nullable().required("Alíquota ad rem do Imposto"),
    otherwise: Yup.number().nullable(),
  }),
});

export default grupoTributarioModeloTributacaoValidator;
